module.exports = __webpack_public_path__ + "img/telecel-money-logo.afdef963.jpg";